import { ResidentTypesEnum } from 'common/enums/resident-types.enum';

export const isOccupant = (ownerType?: ResidentTypesEnum) => {
  return (
    ownerType !== ResidentTypesEnum.Renter &&
    ownerType !== ResidentTypesEnum.Owner &&
    ownerType !== ResidentTypesEnum.Manager &&
    ownerType !== ResidentTypesEnum.Realtor &&
    ownerType !== ResidentTypesEnum.NonResident &&
    ownerType !== ResidentTypesEnum.Event &&
    ownerType !== ResidentTypesEnum.Developer &&
    ownerType !== ResidentTypesEnum.Employee &&
    ownerType !== ResidentTypesEnum.ClubMember &&
    ownerType !== ResidentTypesEnum.RentalAgency
  );
};

export const isHost = (ownerType?: ResidentTypesEnum) => {
  return ownerType === ResidentTypesEnum.Renter || ownerType === ResidentTypesEnum.Owner;
};
